module.exports = __webpack_public_path__ + "img/contact2-img18.868e93e1.png";